/**
 * Indian digit grouping (12,34,567) written by hand rather than via
 * `toLocaleString('en-IN')`, because Hermes on Android ships a trimmed Intl
 * and silently falls back to plain grouping.
 */
export function groupIndian(value: number): string {
  const neg = value < 0;
  const digits = String(Math.abs(Math.round(value)));
  if (digits.length <= 3) return (neg ? '-' : '') + digits;

  const last3 = digits.slice(-3);
  const rest = digits.slice(0, -3);
  const grouped = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
  return (neg ? '-' : '') + grouped + ',' + last3;
}

/** Rupee display used everywhere in the app: fmt(1234.4) -> "₹1,234". */
export function fmt(value: number): string {
  return '₹' + groupIndian(value);
}

/** "07:42 PM" — also hand-rolled to stay Hermes-safe. */
export function formatClockTime(date: Date = new Date()): string {
  const h24 = date.getHours();
  const suffix = h24 >= 12 ? 'PM' : 'AM';
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  const mm = String(date.getMinutes()).padStart(2, '0');
  return `${String(h12).padStart(2, '0')}:${mm} ${suffix}`;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "05 Sep 2026" — hand-rolled for the same Hermes reason as the time above. */
export function formatDate(date: Date = new Date()): string {
  const dd = String(date.getDate()).padStart(2, '0');
  return `${dd} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}
